module.exports = __webpack_public_path__ + "static/media/Developmenticon03@2x.f68be09b.png";